module.exports = __webpack_public_path__ + "img/icon1.71f5b7a0.png";